import { useEffect } from 'react';
import { useHistory } from 'react-router-dom'
import { useLoad } from '../../hooks/useLoad';
import { useUser } from '../../hooks/useUser';
import MobileRutas from '../../routes';
import NotificationPrompt from '../../components/NotificationPrompt';
import PushNotification from '../../components/PushNotification'

const LayoutMobile = (props) => {
    const history = useHistory();
    const { isAdminFGS } = useUser()
    const { load, onNotification, noti, setNoti } = useLoad();

    if (isAdminFGS) history.push("/admin");

    useEffect(() => { load() }, []);
    return (
        <>
            <MobileRutas />
            <NotificationPrompt onNotification={onNotification} />

            {noti && (
                <PushNotification
                    title={noti.title}
                    message={noti.message}
                    icon={noti.icon}
                    onClose={() => setNoti(null)}
                />
            )}
        </>
    )
}

export default LayoutMobile;